import { Badge, Button, Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import { getColors, IsMobile } from '../Shared/Functions';
import DrawerComponent from './DrawerComponent';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Alerts } from './Alerts';
import { AlertTypeEnum } from '../../services/V2/gozer';

export function Navigation ({ account }) {
    let history = useHistory();
    let location = useLocation();
    const [selectedTab, setSelectedTab] = useState<any>(0);
    let [secondary, setSecondary] = useState<any>("white");
    let [tertiary, setTertiary] = useState<any>("#424449");
    const [open, setOpen] = useState<any>(true);
    const [alertMessage, setAlertMessage] = useState<any>(null);

    useEffect(() => {
        setAlertMessage(account?.alertMessages?.find(x => x.alertType === AlertTypeEnum.GENERIC)?.message)
    }, [account])

    useEffect(() => {
        getColors().then((x: any) => {
            setSecondary(x.secondary)
            setTertiary(x.tertiary)
        });
    }, [])

    useEffect(() => {
        switch(location.pathname){
            case '/account':
                setSelectedTab(0);
                break;
            case '/payment':
                setSelectedTab(1);
                break;
            case '/history':
                setSelectedTab(2);
                break;
            case '/wallet':
                setSelectedTab(3);
                break;
            case '/manage':
                setSelectedTab(4);
                break;
        }
    }, [location])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e, tab) => {
        if(typeof(tab) === 'object') {
            return;
        }
        if(tab === 0){
            history.push('/account');
        } else if(tab === 1) {
            history.push('/payment');
        } else if(tab === 2) {
            history.push('/history');
        } else if(tab === 3) {
            history.push('/wallet');
        } else if(tab === 4) {
            history.push('/manage');
        }
        setSelectedTab(tab)
    }

    const handleExpandClick = () => { 
        setOpen(!open); 
     };

    return (
        <>
            {IsMobile() ? (<DrawerComponent alertMessage={alertMessage} />)
            : 
            <Grid style={{ backgroundColor: secondary }}>
                <div>
                    <Tabs value={selectedTab} onChange={handleChange} variant='fullWidth' TabIndicatorProps={{ style: { display: "none" } }}>
                        <Tab style={selectedTab === 0 ? {backgroundColor: tertiary, color:"white"} : {}}
                            label={<div className='nav-tabs' style={selectedTab === 0 ? {color: "white"} : {}}><span className="nav-tabs-icon"><HomeIcon /></span><span>Home</span></div>} value={0} />
                        <Tab style={selectedTab === 1 ? {backgroundColor: tertiary, color:"white"} : {}}
                            label={<div className='nav-tabs' style={selectedTab === 1 ? {color: "white"} : {}}><span className="nav-tabs-icon"><AttachMoneyIcon /></span><span>Make Payment</span></div>} value={1} />
                        <Tab style={selectedTab === 2 ? {backgroundColor: tertiary, color:"white"} : {}}
                            label={<div className='nav-tabs' style={selectedTab === 2 ? {color: "white"} : {}}><span className="nav-tabs-icon"><FormatListBulletedIcon /></span><span>History</span></div>} value={2} />
                        <Tab style={selectedTab === 3 ? {backgroundColor: tertiary, color:"white"} : {}}
                            label={<div className='nav-tabs' style={selectedTab === 3 ? {color: "white"} : {}}><span className="nav-tabs-icon"><CreditCardIcon /></span><span>Wallet</span></div>} value={3} />
                        <Tab style={selectedTab === 4 ? {backgroundColor: tertiary, color:"white"} : {}}
                            label={<div className='nav-tabs' style={selectedTab === 4 ? {color: "white"} : {}}><span className="nav-tabs-icon"><PersonIcon /></span><span>My Account</span></div>} value={4} />
                        {alertMessage &&
                            <Button onClick={handleExpandClick} style={{ maxWidth: "20px" }} aria-label="Show alerts">
                                <Badge badgeContent={"!"} color="primary"><NotificationsIcon style={{ color: "black" }} /></Badge>
                            </Button>
                        }
                    </Tabs>
                </div>
                <Alerts open={open} alertMessage={alertMessage} />
            </Grid>
            }
        </>
    );
}